import { call } from 'redux-saga/effects';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safe = <A>(recovery: (error: unknown) => void, saga: (action: A) => any) =>
    function* (action: A) {
        try {
            yield call(saga, action);
        } catch (error) {
            yield call(recovery, error);
        }
    };
